/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_HeadlineInputs */

const en_signin_headline = /** @type {(inputs: Signin_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Humans + AI, one board.`)
};

const id_signin_headline = /** @type {(inputs: Signin_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim manusia + AI, satu papan kerja.`)
};

/**
* | output |
* | --- |
* | "Humans + AI, one board." |
*
* @param {Signin_HeadlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_headline = /** @type {((inputs?: Signin_HeadlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_HeadlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_headline(inputs)
	return en_signin_headline(inputs)
});